import { FieldPath, get, useFormContext } from "react-hook-form";
import { getSegmentResult, getTemplateResult } from "../lookup/utils";
import { produce } from "immer";
import { TemplateResults, TestEventResults, TestResult, TestResults, WelderResults } from "@/api/williams/testEvents";

import styles from "./TestResults.module.css";

type TestRowProps = {
  welder: WelderResults;
  template: TemplateResults;
  test: TestResults;
  path: FieldPath<TestEventResults>;
  isLocked: boolean;
};

export function TestRow({ welder, template, test, path, isLocked }: TestRowProps) {
  const form = useFormContext<TestEventResults>();
  const error = get(form.formState.errors, path);

  function handleResultChanged(e: React.ChangeEvent<HTMLSelectElement>) {
    const updatedTest = produce(test, (draft) => {
      draft.result = parseInt(e.target.value) as TestResult;
    });

    const formData = form.getValues();
    const updatedWelder = updateWelder(welder, updatedTest);
    form.setValue(`welders.${formData.welders.indexOf(welder)}`, updatedWelder, {
      shouldDirty: true,
    });
  }

  return (
    <div className="d-flex justify-content-between mt-2">
      <div className="px-2">
        {test.testType}
        {test.acceptanceCriteria && <span className="d-none d-md-inline">({test.acceptanceCriteria})</span>}
      </div>
      <div className="d-flex gap-2 text-center">
        <div className={styles.field}>
          <select
            value={test.result}
            disabled={template.submitted || isLocked}
            className={`form-select ${error?.result ? "border-danger" : ""}`}
            onChange={handleResultChanged}
          >
            <option value={TestResult.None}></option>
            <option value={TestResult.Pass}>Acceptable</option>
            <option value={TestResult.Fail}>Failed</option>
            <option value={TestResult.NotConducted}>Not Conducted</option>
          </select>
        </div>
      </div>
    </div>
  );

  function updateWelder(welder: WelderResults, updatedTest: TestResults): WelderResults {
    return produce(welder, (draft) => {
      for (const template of draft.templates) {
        for (const segment of template.segments) {
          for (const test of segment.tests) {
            if (test.testId === updatedTest.testId) {
              test.result = updatedTest.result;
              segment.result = getSegmentResult(segment);
              template.result = getTemplateResult(template);
              break;
            }
          }
        }
      }
    });
  }
}
